module.exports = __webpack_public_path__ + "static/01-34b34373e25efc6f81cb97c9546f9d26.jpg";